import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, TwitterIcon, FacebookIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="w-full bg-[#050505] border-t border-[#C9A84C]/20" data-id="element-249">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8" data-id="element-250">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center mb-14" data-id="element-251">
          <img src="https://cdn.magicpatterns.com/uploads/3mfGwa43p9opfbVaZRbDAm/ChatGPT_Image_Jun_16,_2026,_05_52_49_PM.png" alt="MK Lounge on U Logo" className="h-24 w-auto object-contain mb-4" data-id="element-252" />
          <div className="w-24 h-px bg-[#C9A84C]/30 mx-auto" data-id="element-253" />
        </motion.div>

        {/* 4-column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14" data-id="element-254">
          {/* About */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0
        }} data-id="element-255">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-256">
              ABOUT
            </h4>
            <p className="font-inter font-light text-white/50 text-sm leading-relaxed" data-id="element-257">
              Washington DC's most exclusive nightlife destination. Where luxury
              meets the night.
            </p>
            <div className="flex gap-3 mt-5" data-id="element-258">
              <a href="https://instagram.com/mk_on_u" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#C9A84C]/30 text-[#C9A84C]/70 hover:border-[#C9A84C] hover:text-[#C9A84C] transition-all duration-300" aria-label="Instagram" data-id="element-259">
                <InstagramIcon size={15} data-id="element-260" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#C9A84C]/30 text-[#C9A84C]/70 hover:border-[#C9A84C] hover:text-[#C9A84C] transition-all duration-300" aria-label="Twitter" data-id="element-261">
                <TwitterIcon size={15} data-id="element-262" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#C9A84C]/30 text-[#C9A84C]/70 hover:border-[#C9A84C] hover:text-[#C9A84C] transition-all duration-300" aria-label="Facebook" data-id="element-263">
                <FacebookIcon size={15} data-id="element-264" />
              </a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-265">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-266">
              QUICK LINKS
            </h4>
            <ul className="space-y-2.5" data-id="element-267">
              {['EVENTS', 'RESERVATIONS', 'BOTTLE SERVICE', 'GALLERY', 'FAQ', 'PRESS'].map(link => <li key={link} data-id="element-268">
                  <a href="#" className="font-inter font-light text-sm text-white/50 hover:text-[#C9A84C] transition-colors duration-300 flex items-center gap-2 group" data-id="element-269">
                    <span className="w-3 h-px bg-[#C9A84C]/30 group-hover:w-5 group-hover:bg-[#C9A84C] transition-all duration-300" data-id="element-270" />
                    {link}
                  </a>
                </li>)}
            </ul>
          </motion.div>

          {/* Contact */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-271">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-272">
              CONTACT
            </h4>
            <ul className="space-y-3" data-id="element-273">
              <li className="flex items-start gap-3" data-id="element-274">
                <MapPinIcon size={14} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-275" />
                <span className="font-inter font-light text-sm text-white/50" data-id="element-276">
                  913 U St NW
                  <br data-id="element-277" />
                  Washington, DC 20001
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-278">
                <PhoneIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-279" />
                <a href="tel:+12025181161" className="font-inter font-light text-sm text-white/50 hover:text-[#C9A84C] transition-colors" data-id="element-280">
                  (202) 518-1161
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-281">
                <PhoneIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-282" />
                <div className="flex flex-col" data-id="element-283">
                  <span className="font-inter font-light text-[10px] text-white/30 mb-0.5" data-id="element-284">
                    RESERVATIONS / TEXT
                  </span>
                  <a href="sms:2029095158" className="font-inter font-light text-sm text-white/50 hover:text-[#C9A84C] transition-colors" data-id="element-285">
                    (202) 909-5158
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3" data-id="element-286">
                <MailIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-287" />
                <a href="mailto:mkloung@gmail.com" className="font-inter font-light text-sm text-white/50 hover:text-[#C9A84C] transition-colors" data-id="element-288">
                  mkloung@gmail.com
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Hours */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-289">
            <h4 className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C] mb-4" data-id="element-290">
              HOURS
            </h4>
            <ul className="space-y-2" data-id="element-291">
              {[{
              day: 'Mon – Thu',
              hours: '5 PM — 2 AM'
            }, {
              day: 'Fri & Sat',
              hours: '2 PM — 3 AM'
            }, {
              day: 'Sunday',
              hours: '2 PM — 2 AM'
            }].map(({
              day,
              hours
            }) => <li key={day} className="flex justify-between items-center" data-id="element-292">
                  <span className="font-inter font-light text-sm text-white/50" data-id="element-293">
                    {day}
                  </span>
                  <span className="font-inter text-xs text-[#C9A84C]/80" data-id="element-294">
                    {hours}
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 p-3 bg-[#C9A84C]/10 border border-[#C9A84C]/20 rounded-lg" data-id="element-295">
              <p className="font-montserrat text-[9px] tracking-widest text-[#C9A84C] mb-1" data-id="element-296">
                DRESS CODE
              </p>
              <p className="font-inter text-xs text-white/60" data-id="element-297">
                Upscale attire required. Management reserves the right of
                admission.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#C9A84C]/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-298">
          <p className="font-inter font-light text-xs text-white/30" data-id="element-299">
            © 2026 MK Lounge on U. All rights reserved.
          </p>
          <p className="font-inter font-light text-xs text-white/20 italic" data-id="element-300">
            Crafted for the night
          </p>
          <div className="flex gap-4" data-id="element-301">
            <a href="#" className="font-inter text-xs text-white/30 hover:text-[#C9A84C]/60 transition-colors" data-id="element-302">
              Privacy
            </a>
            <a href="#" className="font-inter text-xs text-white/30 hover:text-[#C9A84C]/60 transition-colors" data-id="element-303">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}